import React from "react";
import DefaultImagingSettingTextBox from "./DefaultImagingSettingTextBox";
import { LipidPhaseDropLocatorCaptureProperty } from "../../../Model/CaptureProfile";
import "./LcpDropLocator.css";

const MIN_DROP_SIZE_IN_MICRONS = "minDropSizeInMicrons";
const MAX_DROP_SIZE_IN_MICRONS = "maxDropSizeInMicrons";
const DROP_WHITE_PIXEL_MIN = "dropWhitePixelMin";
const DROP_WHITE_PIXEL_MAX = "dropWhitePixelMax";
const DROP_OPEN_ITERATIONS = "dropOpenIterations";
const LIPID_PHASE_BINARIZER_WHITE_PIXEL_MIN =
  "lipidPhaseBinarizerWhitePixelMin";
const LIPID_PHASE_BINARIZER_WHITE_PIXEL_MAX =
  "lipidPhaseBinarizerWhitePixelMax";
const LIPID_PHASE_OPEN_ITERATIONS = "lipidPhaseOpenIterations";

type Props = {
  style: React.CSSProperties;
  lipidPhaseDropLocator: LipidPhaseDropLocatorCaptureProperty;
  onChange: (
    lipidPhaseDropLocator: LipidPhaseDropLocatorCaptureProperty
  ) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function LcpDropLocator({
  style,
  lipidPhaseDropLocator,
  onChange,
  onErrorOccur,
  onErrorCleared,
}: Props) {
  const onValueChanged = (name: string, value: number) => {
    onChange({
      ...lipidPhaseDropLocator,
      [name]: value,
    });
  };

  const lcpDropLocator = lipidPhaseDropLocator;
  return (
    <div
      className="lcp-dl"
      style={{
        ...style,
      }}
    >
      <DefaultImagingSettingTextBox
        value={lcpDropLocator[MIN_DROP_SIZE_IN_MICRONS]}
        onChange={onValueChanged}
        label="Min. Drop Size"
        name={MIN_DROP_SIZE_IN_MICRONS}
        unit="µm"
        style={{
          gridArea: "aa",
        }}
        min={0}
        max={100000}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />
      <DefaultImagingSettingTextBox
        value={lcpDropLocator[MAX_DROP_SIZE_IN_MICRONS]}
        onChange={onValueChanged}
        label="Max. Drop Size"
        name={MAX_DROP_SIZE_IN_MICRONS}
        unit="µm"
        style={{
          gridArea: "ba",
        }}
        min={lcpDropLocator[MIN_DROP_SIZE_IN_MICRONS] + 1}
        max={100000}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={lcpDropLocator[DROP_WHITE_PIXEL_MIN]}
        onChange={onValueChanged}
        label="Drop White Pixel Min"
        name={DROP_WHITE_PIXEL_MIN}
        unit=""
        style={{
          gridArea: "ab",
        }}
        isInteger={true}
        disabled={false}
        min={0}
        max={255}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={lcpDropLocator[DROP_WHITE_PIXEL_MAX]}
        onChange={onValueChanged}
        label="Drop White Pixel Max"
        name={DROP_WHITE_PIXEL_MAX}
        unit=""
        style={{
          gridArea: "bb",
        }}
        min={lcpDropLocator[DROP_WHITE_PIXEL_MIN] + 1}
        max={255}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={lcpDropLocator[DROP_OPEN_ITERATIONS]}
        onChange={onValueChanged}
        label="Drop Open Iterations"
        name={DROP_OPEN_ITERATIONS}
        unit=""
        style={{
          gridArea: "ac",
        }}
        min={1}
        max={100}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={lcpDropLocator[LIPID_PHASE_OPEN_ITERATIONS]}
        onChange={onValueChanged}
        label="LP Open Iterations"
        name={LIPID_PHASE_OPEN_ITERATIONS}
        unit=""
        style={{
          gridArea: "bc",
        }}
        min={1}
        max={100}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={lcpDropLocator[LIPID_PHASE_BINARIZER_WHITE_PIXEL_MIN]}
        onChange={onValueChanged}
        label="LP White Pixel Min"
        name={LIPID_PHASE_BINARIZER_WHITE_PIXEL_MIN}
        unit=""
        style={{
          gridArea: "ad",
        }}
        min={0}
        max={255}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={lcpDropLocator[LIPID_PHASE_BINARIZER_WHITE_PIXEL_MAX]}
        onChange={onValueChanged}
        label="LP White Pixel Max"
        name={LIPID_PHASE_BINARIZER_WHITE_PIXEL_MAX}
        unit=""
        style={{
          gridArea: "bd",
        }}
        min={lcpDropLocator[LIPID_PHASE_BINARIZER_WHITE_PIXEL_MIN] + 1}
        max={255}
        isInteger={true}
        disabled={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />
    </div>
  );
}
